import { IonContent, IonPage, IonText } from "@ionic/react"
import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router"
import { Avatar_02, Avatar_16 } from "../../../Entryfile/imagepath";
import service from "../../../Service/service";
import Head from "../../Header";
import Sidebar from "../../Sidebar";

const HRViewEmployeee: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    const [id, setId]: any = useState("")
    const location: any = useLocation();

    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            if (location.state) {
                console.log(location)
                setId(location.state.Id)
                View(location.state.Id);
            }

        }
    }, [token, history]);

    const [roleuser] = useState(localStorage.getItem("UserRole"));

    /*........... View ............ */
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [empCode, setEmpCode] = useState("");
    const [designation, setDesignation] = useState("");
    const [doj, setDoj] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [DOB, setDOB] = useState("");
    const [PresentAddress, setPresentAddress] = useState("");
    const [gender, setGenter] = useState("");
    const [reportingPerson, setReportingPerson] = useState([]);
    const [report, setReport] = useState("")
    const [contact, setContact] = useState("");
    const [bloodGroup, setBloodGroup] = useState("");
    const [ERelationship, setERelationship] = useState("");
    const [martialStatus, setMaritialStatus] = useState("");
    const [phone, setPhone] = useState("");
    const [Location, setLocation] = useState("");
    const [fathername, setFathername] = useState("");
    const [dol, setDol] = useState("");
    const [employeeStatus, setEmployeestatus] = useState("");
    const [category, setCategory] = useState("");
    const [role, setRole] = useState("");
    const [PermanentAddress, setPermanantAddress] = useState("");
    const [pfNo, setPfNo] = useState("");
    const [esiNo, setEsiNo] = useState("");
    const [insurance, setInsurance] = useState("");
    const [insuranceValidity, setInsuranceValidity] = useState("");
    const [department, setDeapartment] = useState("");
    const [business, setBusiness] = useState("");
    const [aadhaar, setAadhaar] = useState("");
    const [panNo, setPanNo] = useState("");
    const [passport, setPassPort] = useState("");
    const [passportValidity, setPassPortvalidity] = useState("");
    const [employeeDetail, setEmployeeDetail] = useState([]);
    const [xthinstitute, setXthinstitute] = useState("");
    const [xthpassyear, setXthpassyear] = useState("");
    const [xthboard, setXthboard] = useState("");
    const [xthpercentage, setXthpercentage] = useState("");
    const [xiithinstitute, setXIIthinstitute] = useState("");
    const [xiithpassyear, setXIIthpassyear] = useState("");
    const [xiithcoresubject, setXIIthcoresubject] = useState("");
    const [xiithpercentage, setXIIthpercentage] = useState("");
    const [college, setCollege] = useState([]);
    const [techskill, setTechskill] = useState([]);
    const [certificate, setCertificate] = useState([]);
    const [coverage, setCoverage] = useState([]);
    const [statusFlag, setStatusFlag] = useState(false);

    const [visible, setVisible] = useState(0);


    const View = (id: any) => {

        service.ViewEmpolyeeById(id)
            .then((response) => {
                setStatusFlag(response.data.Data.statusFlag === true);
                console.log(response, "gk");
                if (response.data.Data.employeeCode === null || response.data.Data.employeeCode === "") {
                    setEmpCode("NA");
                }
                else {
                    setEmpCode(response.data.Data.employeeCode)
                }
                if (response.data.Data.name === null || response.data.Data.name === "") {
                    setName("NA");
                }
                else {
                    setName(response.data.Data.name)
                }
                if (response.data.Data.lastName === null || response.data.Data.lastName === "") {
                    setLastname("NA");
                }
                else {
                    setLastname(response.data.Data.lastName)
                }
                if (response.data.Data.employmentDesignation === null || response.data.Data.designation === "") {
                    setDesignation("NA");
                }
                else {
                    setDesignation(response.data.Data.employmentDesignation.designationName)
                }
                if (response.data.Data.dateOfJoining === null || response.data.Data.dateOfJoining === "") {
                    setDoj("NA");
                }
                else {
                    setDoj(moment(response.data.Data.dateOfJoining).format("DD-MM-YYYY"));
                }
                if (response.data.Data.mobile === null || response.data.Data.mobile === "") {
                    setMobile("NA");
                }
                else {
                    setMobile(response.data.Data.mobile)
                }
                if (response.data.Data.emailId === null || response.data.Data.emailId === "") {
                    setEmail("NA");
                }
                else {
                    setEmail(response.data.Data.emailId)
                }
                if (response.data.Data.dateOfBirth === null || response.data.Data.dateOfBirth === "") {
                    setDOB("NA");
                }
                else {
                    setDOB(moment(response.data.Data.dateOfBirth).format("DD-MM-YYYY"))
                }
                const presentAddressParts = [
                    response.data.Data.presentAddressLine1,
                    response.data.Data.presentAddressLine2,
                    response.data.Data.presentAddressCity,
                    response.data.Data.presentAddressPinCode,
                ];

                const isAddressEmpty = presentAddressParts.every(part => part === null || part === '');

                let presentAddress;
                if (isAddressEmpty) {
                    presentAddress = 'NA';
                } else {
                    presentAddress = presentAddressParts
                        .filter(part => part !== null && part !== '')
                        .join(', ');
                }

                setPresentAddress(presentAddress);
                if (response.data.Data.gender.gender === null || response.data.Data.gender.gender === "") {
                    setGenter("NA");
                }
                else {
                    setGenter(response.data.Data.gender.gender)
                }
                if (response.data.Data.emergencyContactNumber === null || response.data.Data.emergencyContactNumber === "") {
                    setContact("NA");
                }
                else {
                    setContact(response.data.Data.emergencyContactNumber)
                }
                if (response.data.Data.bloodGroup === null || response.data.Data.bloodGroup === "") {
                    setBloodGroup("NA");
                }
                else {
                    setBloodGroup(response.data.Data.bloodGroup)
                }
                if (response.data.Data.emergencyContactRelation === null || response.data.Data.emergencyContactRelation === "") {
                    setERelationship("NA");
                }
                else {
                    setERelationship(response.data.Data.emergencyContactRelation)
                }
                if (response.data.Data.martialStatus === null || response.data.Data.martialStatus === "") {
                    setMaritialStatus("NA");
                }
                else {
                    setMaritialStatus(response.data.Data.martialStatus.status);
                }
                if (response.data.Data.phone === null || response.data.Data.phone === "") {
                    setPhone("NA");
                }
                else {
                    setPhone(response.data.Data.phone)
                }
                if (response.data.Data.employeeLocation === null || response.data.Data.employeeLocation === "") {
                    setLocation("NA");
                }
                else {
                    setLocation(response.data.Data.employeeLocation)
                }
                if (response.data.Data.fathername === null || response.data.Data.fathername === "") {
                    setFathername("NA");
                }
                else {
                    setFathername(response.data.Data.fathername)
                }
                if (response.data.Data.dateOfLeave === null || response.data.Data.dateOfLeave === "") {
                    setDol("NA");
                }
                else {
                    setDol(response.data.Data.dateOfLeave)
                }
                if (response.data.Data.employeeStatus.employeeStatus === null || response.data.Data.employeeStatus.employeeStatus === "") {
                    setEmployeestatus("NA");
                }
                else {
                    setEmployeestatus(response.data.Data.employeeStatus.employeeStatus)
                }
                if (response.data.Data.employeeCategory === null || response.data.Data.employeeCategory === "") {
                    setCategory("NA");
                }
                else {
                    setCategory(response.data.Data.employeeCategory.employmentTypesName)
                }
                if (response.data.Data.roleId === null || response.data.Data.roleId === "") {
                    setRole("NA")
                }
                else {
                    setRole(response.data.Data.role);
                }
                const permanantAddressParts = [
                    response.data.Data.permanentAddressLine1,
                    response.data.Data.permanentAddressLine2,
                    response.data.Data.permanentAddressCity,
                    response.data.Data.permanentAddressPinCode,
                ];

                const AddressEmpty = permanantAddressParts.every(part => part === null || part === '');

                let PermanentAddress;
                if (AddressEmpty) {
                    PermanentAddress = 'NA';
                } else {
                    PermanentAddress = permanantAddressParts
                        .filter(part => part !== null && part !== '')
                        .join(', ');
                }

                setPermanantAddress(PermanentAddress);
                if (response.data.Data.aadhaar === null || response.data.Data.aadhaar === "") {
                    setAadhaar("NA");
                }
                else {
                    setAadhaar(response.data.Data.aadhaar)
                }
                if (response.data.Data.pan === null || response.data.Data.pan === "") {
                    setPanNo("NA");
                }
                else {
                    setPanNo(response.data.Data.pan)
                }
                if (response.data.Data.passport === null || response.data.Data.passport === "") {
                    setPassPort("NA");
                }
                else {
                    setPassPort(response.data.Data.passport)
                }
                if (response.data.Data.passportValidity === null || response.data.Data.passportValidity === "") {
                    setPassPortvalidity("NA");
                }
                else {
                    setPassPortvalidity(response.data.Data.passportValidity)
                }
                if (response.data.Data.pfNo === null || response.data.Data.pfNo === "") {
                    setPfNo("NA");
                }
                else {
                    setPfNo(response.data.Data.pfNo)
                }
                if (response.data.Data.esiNo === null || response.data.Data.esiNo === "") {
                    setEsiNo("NA");
                }
                else {
                    setEsiNo(response.data.Data.esiNo)
                }
                if (response.data.Data.groupInsurance === null || response.data.Data.groupInsurance === "") {
                    setInsurance("NA");
                }
                else {
                    setInsurance(response.data.Data.groupInsurance)
                }
                if (response.data.Data.insuranceValidity === null || response.data.Data.insuranceValidity === "") {
                    setInsuranceValidity("NA");
                }
                else {
                    setInsuranceValidity(response.data.Data.insuranceValidity)
                }
                if (response.data.Data.masterDepartment === null || response.data.Data.masterDepartment === "") {
                    setDeapartment("NA");
                }
                else {
                    setDeapartment(response.data.Data.masterDepartment.departmentName)
                }
                if (response.data.Data.businessUnit === null || response.data.Data.businessUnit === "") {
                    setBusiness("NA");
                }
                else {
                    setBusiness(response.data.Data.businessUnit.businessUnitName)
                }

                if (response.data.Data.employmentDetails === null) {
                    setEmployeeDetail([])
                }
                else if (response.data.Data.employmentDetails.length > 0) {
                    setEmployeeDetail(response.data.Data.employmentDetails)
                }

                if (response.data.Data.xthInstitutionName === null || response.data.Data.xthInstitutionName === "") {
                    setXthinstitute("NA");
                }
                else {
                    setXthinstitute(response.data.Data.xthInstitutionName)
                }
                if (response.data.Data.xthPassingYear === null || response.data.Data.xthPassingYear === "") {
                    setXthpassyear("NA");
                }
                else {
                    setXthpassyear(response.data.Data.xthPassingYear)
                }
                if (response.data.Data.xthboard === null || response.data.Data.xthboard === "") {
                    setXthboard("NA");
                }
                else {
                    setXthboard(response.data.Data.xthboard)
                }
                if (response.data.Data.xthPassPercentage === null || response.data.Data.xthPassPercentage === "") {
                    setXthpercentage("NA");
                }
                else {
                    setXthpercentage(response.data.Data.xthPassPercentage)
                }
                if (response.data.Data.institutionName === null || response.data.Data.institutionName === "") {
                    setXIIthinstitute("NA");
                }
                else {
                    setXIIthinstitute(response.data.Data.institutionName)
                }
                if (response.data.Data.passingYear === null || response.data.Data.passingYear === "") {
                    setXIIthpassyear("NA");
                }
                else {
                    setXIIthpassyear(response.data.Data.passingYear)
                }
                if (response.data.Data.coreSubject === null || response.data.Data.coreSubject === "") {
                    setXIIthcoresubject("NA");
                }
                else {
                    setXIIthcoresubject(response.data.Data.coreSubject)
                }
                if (response.data.Data.passPercentage === null || response.data.Data.passPercentage === "") {
                    setXIIthpercentage("NA");
                }
                else {
                    setXIIthpercentage(response.data.Data.passPercentage)
                }

                if (response.data.Data.reportingManager === null || response.data.Data.reportingManager.length === 0) {
                    setReportingPerson([])
                    setReport("NA");
                }
                else if (response.data.Data.reportingManager.length > 0) {
                    setReportingPerson(response.data.Data.reportingManager)
                    for (let i = 0; i < response.data.Data.reportingManager.length; i++) {
                        var reporting = (response.data.Data.reportingManager[i]).split(",")
                        setReport(reporting[1])
                    }
                }

                if (response.data.Data.institutions === null || "") {
                    setCollege([])
                }
                else if (response.data.Data.institutions.length > 0) {
                    setCollege(response.data.Data.institutions)
                }

                if (response.data.Data.skillsDetails === null || response.data.Data.skillsDetails.length === 0) {
                    setTechskill([])
                }
                else if (response.data.Data.skillsDetails.length > 0) {
                    setTechskill(response.data.Data.skillsDetails)
                }

                if (response.data.Data.certificates === null || response.data.Data.certificates.length === 0) {
                    setCertificate([])
                }
                else if (response.data.Data.certificates.length > 0) {
                    setCertificate(response.data.Data.certificates)
                }

                if (response.data.Data.insuranceCoverages === null || response.data.Data.insuranceCoverages === "") {
                    setCoverage([])
                }
                else if (response.data.Data.insuranceCoverages.length > 0) {
                    setCoverage(response.data.Data.insuranceCoverages)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const toggleDiv = () => {
        setVisible(0);
    }

    const toggleDiv1 = () => {
        setVisible(1);
    }

    const toggleDiv2 = () => {
        setVisible(2);
    }

    const toggleDiv3 = () => {
        setVisible(3);
    }

    const toggleDiv4 = () => {
        setVisible(4);
    }

    const toggleDiv5 = () => {
        setVisible(5);
    }

    const toggleDiv6 = () => {
        setVisible(6);
    }

    const Update = () => {
        history.push({ pathname: "/HRUpdateEmployee", state: { Id: id } })
    }

    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer" }} /> Profile</h3>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-0">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="profile-view">
                                        <div className="profile-img-wrap">
                                            <div className="profile-img">
                                                <a><img alt="" src={Avatar_02} /></a>
                                            </div>
                                        </div>
                                        <div className="profile-basic">
                                            <div className="row">
                                                <div className="col-md-5 profile-info-left">
                                                    <div>
                                                        {/* <h3 className="user-name m-t-0 mb-0">{name} </h3>
                                                        <h6 className="text-muted">{designation}</h6> */}
                                                        <div className="staff-id" style={{color:'black'}}>Employee Code : {empCode}</div>
                                                        <div className="small doj text-muted">Date of Join : {doj}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md-7">
                                                    {
                                                        (roleuser === "ADMIN" || roleuser === "Admin" || roleuser === "admin" || roleuser === "BUSINESS_UNIT_HEAD") &&
                                                        (statusFlag ? (
                                                            <a onClick={() => Update()} className="edit-icon">
                                                                <i className="fa fa-pencil" />
                                                            </a>
                                                        ) : null)
                                                    }
                                                    {/* {roleuser === "ADMIN" || roleuser === "Admin" || roleuser === "admin" || roleuser === "BUSINESS_UNIT_HEAD" && visible === 1 ?
                                                        <a onClick={() => Update()} className="edit-icon"><i className="fa fa-pencil" /></a>
                                                        : <></>
                                                    } */}
                                                    <ul className="personal-info">
                                                        <li>
                                                            <div className="title">Mobile:</div>
                                                            <div className="text"><a>{mobile}</a></div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Email:</div>
                                                            <div className="text"><a>{email}</a></div>
                                                        </li>
                                                        {/* <li>
                                                            <div className="title">DOB:</div>
                                                            <div className="text">{DOB}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Address:</div>
                                                            <div className="text">{PresentAddress}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Gender:</div>
                                                            <div className="text">{gender}</div>
                                                        </li> */}
                                                        {/* {reportingPerson.length > 0 &&
                                                            <li>
                                                                <div className="title">Reports to:</div>
                                                                <div className="text">
                                                                    <div className="avatar-box">
                                                                        <div className="avatar avatar-xs">
                                                                            <img src={Avatar_16} alt="" />
                                                                        </div>
                                                                    </div>
                                                                    {reportingPerson.map((itm: any) => {
                                                                        var report = (itm).split(',')
                                                                        return (
                                                                            <div>
                                                                                {report[1]}
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </li>} */}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card tab-box">
                        <div className="row user-tabs">
                            <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                    <li className="nav-item"><a onClick={() => toggleDiv()} data-bs-toggle="tab" className={visible === 0 ? "nav-link active" : "nav-link"}>Personal Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv1()} data-bs-toggle="tab" className={visible === 1 ? "nav-link active" : "nav-link"}>Organization Details</a></li>
                                    {/* <li className="nav-item"><a onClick={() => toggleDiv2()} data-bs-toggle="tab" className={visible === 2 ? "nav-link active" : "nav-link"}>Identification (KYC)</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv3()} data-bs-toggle="tab" className={visible === 3 ? "nav-link active" : "nav-link"}>Statutory Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv4()} data-bs-toggle="tab" className={visible === 4 ? "nav-link active" : "nav-link"}>Skill Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv5()} data-bs-toggle="tab" className={visible === 5 ? "nav-link active" : "nav-link"}>Educational Details</a></li>
                                    <li className="nav-item"><a onClick={() => toggleDiv6()} data-bs-toggle="tab" className={visible === 6 ? "nav-link active" : "nav-link"}>Employment Details</a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content" style={{ padding: "0px" }}>
                        {visible === 0 ?
                            <div className="pro-overview tab-pane fade show active">
                                <div className="row">
                                    <div className="col-md-12 d-flex">
                                        <div className="card profile-box flex-fill">
                                            <div className="card-body">
                                                <h3 className="card-title">Personal Informations </h3>
                                                <ul className="personal-info">
                                                    {/* <li>
                                                        <div className="title">Employee Code</div>
                                                        <div className="text">{empCode}</div>
                                                    </li> */}
                                                    <li>
                                                        <div className="title">Name</div>
                                                        <div className="text">{name}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Last Name</div>
                                                        <div className="text">{lastname}</div>
                                                    </li>
                                                    {/* <li>
                                                        <div className="title">Emergency Contact Number</div>
                                                        <div className="text">{contact}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Emergency Contact Relationship</div>
                                                        <div className="text">{ERelationship}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Gender</div>
                                                        <div className="text">{gender}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Blood Group</div>
                                                        <div className="text">{bloodGroup}</div>
                                                    </li> */}
                                                    {/* <li>
                                                        <div className="title">Marital Status</div>
                                                        <div className="text">{martialStatus}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Land Line</div>
                                                        <div className="text">{phone}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Mobile Number</div>
                                                        <div className="text">{mobile}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Employee Location</div>
                                                        <div className="text">{Location}</div>
                                                    </li> */}
                                                    {/* <li>
                                                        <div className="title">Date of Birth</div>
                                                        <div className="text">{DOB}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Father Name</div>
                                                        <div className="text">{fathername}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Employee DOJ</div>
                                                        <div className="text">{doj}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Employee DOL</div>
                                                        <div className="text">{dol}</div>
                                                    </li> */}
                                                    <li>
                                                        <div className="title">Employee Status</div>
                                                        <div className="text">{employeeStatus}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Employee Category</div>
                                                        <div className="text">{category}</div>
                                                    </li>
                                                    {/* <li>
                                                        <div className="title">Email Id</div>
                                                        <div className="text">{email}</div>
                                                    </li> */}
                                                    <li>
                                                        <div className="title">Access Role</div>
                                                        <div className="text">{role}</div>
                                                    </li>
                                                    {/* <li>
                                                        <div className="title">Designation</div>
                                                        <div className="text">{designation}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Current Address</div>
                                                        <div className="text">{PresentAddress}</div>
                                                    </li>
                                                    <li>
                                                        <div className="title">Permanent Addresss</div>
                                                        <div className="text">{PermanentAddress}</div>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :

                            visible === 1 ? (
                                <div className="pro-overview tab-pane fade show active" role="dialog">
                                    <div className="row">
                                        <div className="col-md-12 d-flex">
                                            <div className="card profile-box flex-fill">
                                                <div className="card-body">
                                                    <h3 className="card-title">Organization Information</h3>
                                                    <ul className="personal-info">
                                                        <li>
                                                            <div className="title">Business Unit</div>
                                                            <div className="text">{business}</div>

                                                        </li>
                                                        <li>
                                                            <div className="title">Department Unit</div>
                                                            <div className="text">{department}</div>
                                                        </li>
                                                        <li>
                                                            <div className="title">Reporting Manager</div>
                                                            <div className="text">{report}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )

                                :
                                visible === 2 ?
                                    <div className="pro-overview tab-pane fade show active" role="dialog">
                                        <div className="row">
                                            <div className="col-md-12 d-flex">
                                                <div className="card profile-box flex-fill">
                                                    <div className="card-body">
                                                        <h3 className="card-title">Identification Informations </h3>
                                                        <ul className="personal-info">
                                                            <li>
                                                                <div className="title">AADHAAR No</div>
                                                                <div className="text">{aadhaar}</div>
                                                            </li>
                                                            <li>
                                                                <div className="title">PAN No</div>
                                                                <div className="text">{panNo}</div>
                                                            </li>
                                                            <li>
                                                                <div className="title">Passport No</div>
                                                                <div className="text">{passport}</div>
                                                            </li>
                                                            <li>
                                                                <div className="title">Passport Validity</div>
                                                                <div className="text">{passportValidity}</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    visible === 3 ?
                                        <div className="pro-overview tab-pane fade show active" role="dialog">
                                            <div className="row">
                                                <div className="col-md-12 d-flex">
                                                    <div className="card profile-box flex-fill">
                                                        <div className="card-body">
                                                            <h3 className="card-title">Statutory Informations </h3>
                                                            <ul className="personal-info">
                                                                <li>
                                                                    <div className="title">PF No</div>
                                                                    <div className="text">{pfNo}</div>
                                                                </li>
                                                                <li>
                                                                    <div className="title">ESI No</div>
                                                                    <div className="text">{esiNo}</div>
                                                                </li>
                                                                <li>
                                                                    <div className="title">Group Insurance Details</div>
                                                                    <div className="text">{insurance}</div>
                                                                </li>
                                                                <li>
                                                                    <div className="title">Insurance Validity</div>
                                                                    <div className="text">{insuranceValidity}</div>
                                                                </li>
                                                                <h3 className="card-title" style={{ color: "coral" }}>Coverage</h3>
                                                                {coverage.length > 0 ? coverage.map((item: any, i: any) => (
                                                                    <ul className="personal-info">
                                                                        <div className="row">
                                                                            <div className="col-md-1">
                                                                                <span>{i + 1}.</span>
                                                                            </div>
                                                                            <li className="col-md-5 row">
                                                                                <div className="title">Coverage Name</div>
                                                                                <div className="text">{item.coverageName}</div>
                                                                            </li>
                                                                            <li className="col-md-6 row">
                                                                                <div className="title">Relationship</div>
                                                                                <div className="text">{item.relationship}</div>
                                                                            </li>
                                                                        </div>
                                                                    </ul>
                                                                )) : <div style={{ marginTop: "2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                    <IonText>No Details Found !</IonText>
                                                                </div>}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        visible === 4 ?
                                            <div className="pro-overview tab-pane fade show active" role="dialog">
                                                <div className="row">
                                                    <div className="col-md-12 d-flex">
                                                        <div className="card profile-box flex-fill">
                                                            <div className="card-body">
                                                                <h3 className="card-title">Skill Informations </h3>
                                                                <div style={{ marginTop: "2%" }}>
                                                                    <h3 className="card-title" style={{ color: "coral" }}>Technical Skills</h3>
                                                                    {techskill.length > 0 ? techskill.map((item: any, i: any) => (
                                                                        <ul className="personal-info">
                                                                            <div className="row">
                                                                                <div className="col-md-1">
                                                                                    <span>{i + 1}.</span>
                                                                                </div>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Technical Skills</div>
                                                                                    <div className="text">{item.technicalSkills}</div>
                                                                                </li>
                                                                                <li className="col-md-4 row">
                                                                                    <div className="title">Proficiency</div>
                                                                                    <div className="text">{item.proficiency}</div>
                                                                                </li>
                                                                                <li className="col-md-4 row">
                                                                                    <div className="title">Years of Experience</div>
                                                                                    <div className="text">{item.yearsOfExperience}</div>
                                                                                </li>
                                                                            </div>
                                                                        </ul>
                                                                    )) : <div style={{ marginTop: "2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        <IonText>No Details Found !</IonText>
                                                                    </div>}
                                                                </div>
                                                                <div style={{ marginTop: "2%" }}>
                                                                    <h3 className="card-title" style={{ color: "coral" }}>Professional Certification</h3>
                                                                    {certificate.length > 0 ? certificate.map((item: any, i: any) => (
                                                                        <ul className="personal-info">
                                                                            <div className="row">
                                                                                <div className="col-md-1">
                                                                                    <span>{i + 1}.</span>
                                                                                </div>
                                                                                <li className="col-md-4 row">
                                                                                    <div className="title">Certificate Name</div>
                                                                                    <div className="text">{item.certificateName}</div>
                                                                                </li>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Description</div>
                                                                                    <div className="text">{item.descriptions}</div>
                                                                                </li>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Issued By</div>
                                                                                    <div className="text">{item.issuedBy}</div>
                                                                                </li>
                                                                                <li className="col-md-2 row">
                                                                                    <div className="title">Validity</div>
                                                                                    <div className="text">{item.validity}</div>
                                                                                </li>
                                                                            </div>
                                                                        </ul>
                                                                    )) : <div style={{ marginTop: "2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        <IonText>No Details Found !</IonText>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            visible === 5 ?
                                                <div className="pro-overview tab-pane fade show active" role="dialog">
                                                    <div className="row">
                                                        <div className="col-md-12 d-flex">
                                                            <div className="card profile-box flex-fill">
                                                                <div className="card-body">
                                                                    <h3 className="card-title">Educational Informations </h3>
                                                                    <ul className="personal-info" style={{ marginTop: "1%" }}>
                                                                        <h3 className="card-title" style={{ color: "coral" }}>School X </h3>
                                                                        <li>
                                                                            <div className="title">Institution Name</div>
                                                                            <div className="text">{xthinstitute}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Passing Year</div>
                                                                            <div className="text">{xthpassyear}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Board</div>
                                                                            <div className="text">{xthboard}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Pass Percentage</div>
                                                                            <div className="text">{xthpercentage}</div>
                                                                        </li>
                                                                    </ul>
                                                                    <ul className="personal-info" style={{ marginTop: "1%" }}>
                                                                        <h3 className="card-title" style={{ color: "coral" }}>School XII </h3>
                                                                        <li>
                                                                            <div className="title">Institution Name</div>
                                                                            <div className="text">{xiithinstitute}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Passing Year</div>
                                                                            <div className="text">{xiithpassyear}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Core Subjects</div>
                                                                            <div className="text">{xiithcoresubject}</div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="title">Pass Percentage</div>
                                                                            <div className="text">{xiithpercentage}</div>
                                                                        </li>
                                                                    </ul>
                                                                    <h3 className="card-title" style={{ color: "coral" }}>College </h3>
                                                                    {college.length > 0 ? college.map((item: any, i: any) => (
                                                                        <ul className="personal-info">
                                                                            <div className="row">
                                                                                <div className="col-md-1">
                                                                                    <span>{i + 1}.</span>
                                                                                </div>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Institution Name</div>
                                                                                    <div className="text">{item.instituteName}</div>
                                                                                </li>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">University</div>
                                                                                    <div className="text">{item.university}</div>
                                                                                </li>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Degree</div>
                                                                                    <div className="text">{item.degree}</div>
                                                                                </li>
                                                                                <li className="col-md-3 row">
                                                                                    <div className="title">Core Subjects</div>
                                                                                    <div className="text">{item.coreSubjects}</div>
                                                                                </li>
                                                                                <li className="row">
                                                                                    <li className="col-md-1">
                                                                                        <span />
                                                                                    </li>
                                                                                    <li className="col-md-3 row">
                                                                                        <div className="title">Year of Passing</div>
                                                                                        <div className="text">{item.yearOfPassing}</div>
                                                                                    </li>
                                                                                    <li className="col-md-3 row">
                                                                                        <div className="title">GPA / Marks</div>
                                                                                        <div className="text">{item.gpa}</div>
                                                                                    </li>
                                                                                </li>
                                                                            </div>
                                                                        </ul>
                                                                    )) : <div style={{ marginTop: "2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        <IonText>No Details Found !</IonText>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                visible === 6 ?
                                                    <div className="pro-overview tab-pane fade show active" role="dialog">
                                                        <div className="row">
                                                            <div className="col-md-12 d-flex">
                                                                <div className="card profile-box flex-fill">
                                                                    <div className="card-body">
                                                                        <h3 className="card-title">Employment Informations </h3>
                                                                        {employeeDetail.length > 0 ? employeeDetail.map((item: any, i: any) => (
                                                                            <div style={{ marginTop: "2%" }}>
                                                                                <ul className="personal-info">
                                                                                    <div className="row">
                                                                                        <div className="col-md-1">
                                                                                            <span>{i + 1}.</span>
                                                                                        </div>
                                                                                        <li className="col-md-3 row">
                                                                                            <div className="title">Organization</div>
                                                                                            <div className="text">{item.organization}</div>
                                                                                        </li>
                                                                                        <li className="col-md-3 row">
                                                                                            <div className="title">Description</div>
                                                                                            <div className="text">{item.description}</div>
                                                                                        </li>
                                                                                        <li className="col-md-3 row">
                                                                                            <div className="title">Start YY MM</div>
                                                                                            <div className="text">{item.startyear}</div>
                                                                                        </li>
                                                                                        <li className="col-md-3 row">
                                                                                            <div className="title">End YY MM</div>
                                                                                            <div className="text">{item.endyear}</div>
                                                                                        </li>
                                                                                    </div>
                                                                                </ul>
                                                                            </div>
                                                                        )) : <div style={{ marginTop: "2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                            <IonText>No Details Found !</IonText>
                                                                        </div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : <></>
                        }
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )

}

export default HRViewEmployeee